import EventGroup from './event_group';

export const globalClickEvent = new EventGroup('global-click');
export const globalMenuOpenEvent = new EventGroup('global-menu-event');
